import React, { Component } from "react";
import { Table} from "tabler-react";
import { Crud_Catalogos } from '../../../../herramientas/Crud_Catalogos';
import { ReactReduxContext } from "react-redux";
import { TablePageable } from "../../../../Helpers";
class EtaCalculada extends Component {
    constructor(props) {
        super(props);
        this.state = {
            etaCalculadas: [],
            etaCalculadasN: [],
            ultimoCalculo: true,
        };
    }

    componentDidMount = () => {
        this.getEtaNaviera();

    }

    getEtaNaviera = () => {
        Crud_Catalogos("etaCalculada/movimiento/"+this.props.mov.id, "etaCalculada", "get", "", [], "", this.state.etaCalculadasN, "", []).then((returnVal) => {
            this.etaCalculadasN = returnVal;
            this.setState({ etaCalculadasN: returnVal && returnVal.length? returnVal.sort((a, b) => b.id - a.id ): [] });
        }).catch(err => {
            if (err.response) {
                console.log(err);
            } else {
                /**
                 * Error
                 */
            }
        })
    }
    filtroEtas=()=>{
        if(this.state.ultimoCalculo){
            return this.state.etaCalculadasN.length? this.state.etaCalculadasN.slice(0, 1): [];
        }else{
            return this.state.etaCalculadasN
        }
    }
    render() {
        return (

            <div className="table-responsive">
                <button
                    type="button" className="btn btn-primary btn-sm"
                    onClick={()=> this.setState({ ultimoCalculo: !this.state.ultimoCalculo}) }>
                    <i className="fa fa-code-fork" style={{"font-size": "24px"}}></i>
                    {this.state.ultimoCalculo? "Mostrar todos los cálculos": "Mostrar solo el último cálculo"}
                </button>
                <TablePageable
                    titulo={"Cita: "+this.props.mov.citaProgramada}
                    lista={this.filtroEtas()}
                    columnas={[
                        {   columna: 'id', label: "ID"  },
                        {   columna: 'idMovimiento', label: "Movimiento"   },
                        {   columna: 'origenLatitud', label: "Origen Latitud"  },
                        {   columna: 'origenLongitud', label: "Origen Longitud"    },
                        {   columna: 'origenDireccion', label: "Origen Direccion"  },
                        {   columna: 'destinoLatitud', label: "Destino Latitud"    },
                        {   columna: 'destinoLongitud', label: "Destino Longitud"  },
                        {   columna: 'destinoDireccion', label: "Destino Direccion"  },
                        {   columna: 'fechaCalculo', label: "Fecha Calculo"    },
                        {   columna: 'distancia', label: "Distancia"   },
                        {   columna: 'tiempoString', label: "Tiempo"   },
                        {   columna: 'eta',
                            label: "Eta",
                            valor:(e)=> e.eta,
                            form:(e)=> e.eta <= this.props.mov.citaProgramada
                            ? <span className="badge badge-success">{e.eta}</span>
                            : <span className="badge badge-danger">{e.eta}</span>
                        },
                        {   columna: 'tipoCalculo', label: "Tipo Calculo"},
                        {   columna: 'tipoCorredor', label: "Tipo Corredor"}
                    ]}
                    id= "id"                
                    csvname= "ETAs Calculadas"
                    paginacion= {true}
                    elementosPorPagina= {10}
                />
            </div>
        );
    }
}
export default EtaCalculada;